import React from 'react'
import { billingcardProps } from './billingcard-interface'
import { Col, Row } from 'antd'

const Billingcard = ({ isActive, item, isNGN }: billingcardProps) => {
	return (
		<div className={`rounded-[30px] p-5 mb-[0.9rem] ${isActive ? 'custom-primary-bg-five' : 'bg-appcolorgreyfaint'} `}>
			<Row>
				<Col lg={12} md={24} xs={24}>
					<div className='flex flex-col justify-between h-full p-5'>
						<div className='flex items-center'>
							<div>
								<p className={`font-semibold text-[26px]  mr-[0.6rem] ${isActive ? 'text-appcolorwhite' : 'text-appcolorpurplefaintone'}`}>{item.title}</p>

								<p className={`font-semibold text-[16px]  mr-[0.6rem] ${isActive ? 'text-appcolorwhite' : 'text-appcolorpurplefaintone'}`}>
									{item?.subTitle}
								</p>
							</div>

							{
								isActive ?
									<div className='px-4 py-[0.3rem] bg-appcolorinnerwhitethree rounded-xl'>
										<p className='text-appcolorwhite'>Active</p>
									</div>
									: null
							}
						</div>

						<div>
							<div className='flex items-center'>
								{
									item?.currentAmount === undefined ?
										null :
										<p className={`text-2xl font-semibold ${isActive ? 'text-appcolorwhite' : 'text-appcolorpurpleseight'}`}>
											{isNGN ? '₦' : '£'}
											{item.currentAmount}</p>
								}

								<span className={`${isActive ? 'text-appcolorblackfaintten' : 'text-appcolorpurpleseight'}`}>/{item.period}</span>
							</div>

							{

								isActive ?
									<>
										<p className='text-lg font-semibold text-appcolorblackfaintten'>
											Next receipt payable on
										</p>
										<p className='text-lg font-semibold text-appcolorwhite'>
											22/05/2023
										</p>
									</>
									:
									null
							}
						</div>
					</div>
				</Col>
				<Col lg={12} md={24} xs={24}>
					<div className={`p-5 rounded-[1.25rem]  ${isActive ? 'bg-appcolorinnerwhitefour' : 'bg-appcolorinnerwhitefive'}`}>
						{
							item.details.map((detailItem, index) => (
								<div className='flex items-center mb-[1.3rem] last:mb-0'
									key={`detail-item-${item.title}-${index}`}
								>
									<img src={`/img/vectors/${isActive ? 'whitemark' : 'blackmark'}.svg`} alt="" className='w-5 mr-[0.8rem]' />
									<p className={`text-lg font-medium ${isActive ? 'text-appcolorwhite' : 'text-appcolorpurplefaintone'}`}>{detailItem.title} </p>
									{
										detailItem.isComingSoon ?
											<p className='rounded-[0.3rem] px-[0.3rem] py-[0.1rem] bg-appcolorlightgreen text-appcolorgreentwo  text-xs ml-[0.8rem]'>
												Coming soon!
											</p>
											: null
									}
								</div>
							))
						}
					</div>
				</Col>
			</Row>
		</div>
	)
}

export default Billingcard